export default class ImageValidationError extends Error {

}
